import { Component, DOCUMENT, Inject, OnDestroy, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Subscription, filter } from 'rxjs';
import { AuthService } from './services/auth/auth.service';
import { LoaderService } from './services/loader.service';

/** Routes that render standalone, without the console frame. */
// The facility floor is bare too: handhelds and shared stations need the whole screen, and floor
// staff have no use for the console menu. It draws its own bar with a way back.
const BARE_ROUTES = ['/splash', '/logout', '/unauthorized', '/floor'];

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.css'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('Plus.Admin');
  protected readonly showChrome = signal(true);
  isLoading$: any;

  private navSub?: Subscription;

  constructor(@Inject(DOCUMENT) private document: any,
    private oauthService: OAuthService,
    private authService: AuthService,
    private router: Router,
    private loaderService: LoaderService) {}

  ngOnInit() {
    this.isLoading$ = this.loaderService.isLoading;

    this.syncChrome(this.router.url);
    this.navSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e) => this.syncChrome((e as NavigationEnd).urlAfterRedirects));

    this.authService.initAuth();
  }

  ngOnDestroy(): void {
    this.navSub?.unsubscribe();
  }

  private syncChrome(url: string): void {
    const path = (url || '').split('?')[0].split('#')[0];
    this.showChrome.set(!BARE_ROUTES.some(r => path === r || path.startsWith(r + '/')));
  }
}
